import React from 'react'
import agent from '../agent'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import {
  MERCHANT_LIST_PAGE_LOADED,
  MERCHANT_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import MerchantList from './widgets/MerchantList';

const mapStateToProps = state => ({
  ...state.userList,
  appName: state.common.appName,
  token: state.common.token,
  currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: MERCHANT_LIST_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: MERCHANT_LIST_PAGE_UNLOADED }),
});

class Merchants extends React.Component {
  constructor() {
    super();
  }
  componentWillMount() {
    const payload = agent.Users.merchants()
    this.props.onLoad(payload);
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {

    return (
      <div class='pane'>
        <h1>Merchant list</h1>
        <MerchantList merchants={this.props.merchants} loading={this.props.loading} currentUser={this.props.currentUser} />
      </div >
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Merchants);



// WEBPACK FOOTER //
// ./src/components/Merchants.js